<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter">Acknowledgments</h1>
<p class="nonindent1">The writing of a historical piece of fiction requires research and saddlebags filled with factual material, some useful, some not. I’d like to acknowledge my main beta readers, Rachel Sibucao and Mike Uggla, for reading the raw words and giving much needed feedback.</p>
<p class="indent">This book would not exist without the cynical and extremely talented eye of Lisa Majewski. Her time and effort on this novel as both a first editor and story consultant allowed the birth of this baby. May she live in a world surrounded only by clowns and chocolate.</p>
<p class="indent">I cannot miss this opportunity to thank two fellow authors—C. Courtney Joyner, who helped point me in the direction of my eventual publisher, and Joe R. Lansdale, who should write an entire series of books entitled “Chicken Soup for the Doubting Writer.” His knowledge of the business and solid encouragement over an extended period of time made this book possible in ways he may never know.</p>
<p class="indent">Last, but in no way least, a thank you to editor Hazel Rumney, who tightened and strengthened my novel. We haven’t met face-to-face but there must be something wrong with her as she gets my sense of humor.</p>
<p class="indent">I love you all and will always cherish this entire experience.</p>
<p class="indent"> Love, like the wind, cannot be seen, only felt.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?7b8f8249